import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmpresaTributario } from '../../constants';

const { CriterioApuracao } = EmpresaTributario;

export default function SelectEmpresaTributarioCriterioApuracao(props) {
  const { t } = useTranslation();

  const createOption = ({ id, label }) => (
    <Select.Option value={id}>
      {t(label)}
    </Select.Option>);

  return (
    <Select {...props} >
      {createOption(CriterioApuracao.RegimeCaixa)}
      {createOption(CriterioApuracao.RegimeCompetencia)}
      {createOption(CriterioApuracao.NA)}
    </Select>
  );
}

SelectEmpresaTributarioCriterioApuracao.propTypes = {
  value: PropTypes.oneOf([
    CriterioApuracao.RegimeCaixa.id,
    CriterioApuracao.RegimeCompetencia.id,
    CriterioApuracao.NA.id,
  ]),
  onChange: PropTypes.func,
};
